// Webpack Imports
import * as bootstrap from 'bootstrap';
import * as lightbox2 from '../node_modules/lightbox2/dist/js/lightbox.min';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	// change menu color after scroll
	$(document).scroll(function () {
		var $nav = $(".navbar.fixed-top");
		$nav.toggleClass('bg-light', $(this).scrollTop() > ($nav.height() * .25));
	});


	// const classes = new Set()
	// const observer = new MutationObserver((mutations) => {
	// 	mutations.forEach(function(mutationRecord) {
	// 		mutationRecord.target.className.split(' ').forEach(i => {
	// 			classes.add(i);
	// 		});
	// 		document.querySelectorAll('*').forEach((i) => {
	// 			i.className.split(' ').forEach((j) => classes.add(j));
	// 			//console.log(i.className)
	// 		});
	// 		//console.log(mutationRecord.target.className.split(' '));
	// 	})
	// });
	// const target = document.querySelectorAll('*');
	// target.forEach((e) => observer.observe(e, {attributes:true}))
	// jQuery(window).bind('beforeunload', function(){
	// 	return "Cancel";
	// });


} )();

// [
// 	".home",
// 	".page-template",
// 	".page-template-page-full",
// 	".page-template-page-full-php",
// 	".page",
// 	".page-id-11",
// 	".logged-in",
// 	".admin-bar",
// 	".customize-support",
// 	".nojq",
// 	".quicklinks",
// 	".ab-top-menu",
// 	".menupop",
// 	".ab-item",
// 	".ab-icon",
// 	".screen-reader-text",
// 	".ab-sub-wrapper",
// 	".ab-submenu",
// 	".ab-sub-secondary",
// 	".hide-if-no-customize",
// 	".ab-label",
// 	".updates-available-text",
// 	".awaiting-mod",
// 	".pending-count",
// 	".count-0",
// 	".comments-in-moderation-text",
// 	".ab-top-secondary",
// 	".admin-bar-search",
// 	".ab-empty-item",
// 	".adminbar-input",
// 	".adminbar-button",
// 	".with-avatar",
// 	".display-name",
// 	".avatar",
// 	".avatar-26",
// 	".photo",
// 	".avatar-64",
// 	".screen-reader-shortcut",
// 	".navbar",
// 	".navbar-expand-md",
// 	".fixed-top",
// 	".navbar-light",
// 	".container",
// 	".navbar-brand",
// 	".attachment-full",
// 	".size-full",
// 	".navbar-toggler",
// 	".navbar-toggler-icon",
// 	".collapse",
// 	".navbar-collapse",
// 	".navbar-nav",
// 	".ms-auto",
// 	".fs-7",
// 	".fw-500",
// 	".text-md-center",
// 	".menu-item",
// 	".menu-item-type-post_type",
// 	".menu-item-object-page",
// 	".menu-item-home",
// 	".current-menu-item",
// 	".page_item",
// 	".page-item-11",
// 	".current_page_item",
// 	".nav-item",
// 	".menu-item-55",
// 	".nav-link",
// 	".active",
// 	".menu-item-54",
// 	".menu-item-53",
// 	".menu-item-52",
// 	".menu-item-51",
// 	".menu-item-64",
// 	".menu-item-50",
// 	".carousel",
// 	".slide",
// 	".carousel-inner",
// 	".carousel-item",
// 	".underheader-image",
// 	".high",
// 	".img-fluid",
// 	".w-100",
// 	".object-center",
// 	".object-cover",
// 	".banner",
// 	".carousel-caption",
// 	".d-block",
// 	".left-0",
// 	".right-0",
// 	".carousel-caption-wrapper",
// 	".position-absolute",
// 	".logo",
// 	".d-none",
// 	".d-md-block",
// 	".carousel-sub-wrapper-text",
// 	".text-start",
// 	".w-max",
// 	".bg-white",
// 	".hr-dash",
// 	".w-25",
// 	".mb-3",
// 	".d-sm-block",
// 	".fw-bold",
// 	".fs-0",
// 	".text-uppercase",
// 	".mb-0",
// 	".fs-6",
// 	".btn",
// 	".bg-gray",
// 	".fs-10",
// 	".opacity-50",
// 	".content",
// 	".post-11",
// 	".type-page",
// 	".status-publish",
// 	".hentry",
// 	".d-flex",
// 	".justify-content-center",
// 	".text-center",
// 	".py-5",
// 	".row",
// 	".py-3",
// 	".col-12",
// 	".text-darkblue",
// 	".pb-3",
// 	".fs-5",
// 	".mt-5",
// 	".gradient-linear-mid-white",
// 	".py-4",
// 	".my-3",
// 	".align-items-center",
// 	".col-lg-6",
// 	".translate-video",
// 	".col-lg-5",
// 	".ps-lg-5",
// 	".ps-lg-1",
// 	".mt-4",
// 	".mt-lg-0",
// 	".text-lg-start",
// 	".text-gradient-darkblue",
// 	".mt-3",
// 	".mt-lg-5",
// 	".gradient-linear-from-to-blue",
// 	".text-white",
// 	".px-5",
// 	".fs-11",
// 	".fs-1",
// 	".mb-5",
// 	".bg-darkblue",
// 	".flex-column",
// 	".gradient-linear-to-white",
// 	".pt-5",
// 	".nav",
// 	".team",
// 	".col-md-3",
// 	".col-sm-6",
// 	".position-relative",
// 	".overlay",
// 	".rounded-circle",
// 	".border-7",
// 	".border-transparent",
// 	".border-solid",
// 	".overlay-in",
// 	".fs-8",
// 	".chosen",
// 	".bottom-0",
// 	".arrow-up",
// 	".tab-content",
// 	".col-md-12",
// 	".tab-pane",
// 	".no-p-margin",
// 	".show",
// 	".pb-md-5",
// 	".pb-md-4",
// 	".col-sm-12",
// 	".mb-4",
// 	".mb-md-0",
// 	".mt-2",
// 	".col-md-2",
// 	".p-a-0",
// 	".menu",
// 	".justify-content-end",
// 	".menu-item-privacy-policy",
// 	".ms-3",
// 	".mt-0",
// 	".bg-light",
// 	".collapsing",
// 	".collapsed",
// 	".page-id-39",
// 	".page-item-39",
// 	".low",
// 	".mx-auto",
// 	".justify-content-start",
// 	".justify-content-md-center",
// 	".post-39",
// 	".d-grid",
// 	".rn-process",
// 	".rn-1",
// 	".p-5",
// 	".border-1",
// 	".border-darkblue",
// 	".top-0",
// 	".ms-5",
// 	".w-50",
// 	".rn-2",
// 	".zi-1",
// 	".fs-2",
// 	".pe-none",
// 	".rn-3",
// 	".justify-content-between",
// 	".rn-4",
// 	".rn-5",
// 	".rn-6",
// 	".me-5",
// 	".page-id-42",
// 	".page-item-42",
// 	".ps-md-5",
// 	".ms-md-5",
// 	".post-42",
// 	".py-md-5",
// 	".overflow-hidden",
// 	".gx-md-5",
// 	".flex-row",
// 	".col-md-6",
// 	".mt-md-0",
// 	".text-md-end",
// 	".flex-row-reverse",
// 	".page-id-44",
// 	".page-item-44",
// 	".ps-md-3",
// 	".post-44",
// 	".flex-wrap",
// 	".col-md-4",
// 	".px-4",
// 	".mt-1",
// 	".text-dark",
// 	".trim-mentor-description",
// 	".pt-1",
// 	".fs-12",
// 	".pt-2",
// 	".accordion-header",
// 	".accordion-collapse",
// 	".page-id-46",
// 	".page-item-46",
// 	".ps-md-2",
// 	".post-46",
// 	".carousel-dark",
// 	".carousel-indicators",
// 	".pb-5",
// 	".my-5",
// 	".px-15p",
// 	".col-md-9",
// 	".text-end",
// 	".carousel-control-prev",
// 	".big-icon",
// 	".carousel-control-prev-icon",
// 	".visually-hidden",
// 	".carousel-control-next",
// 	".carousel-control-next-icon",
// 	".fs-3",
// 	".pt-3",
// 	".carousel-item-start",
// 	".carousel-item-next",
// 	".page-id-62",
// 	".page-item-62",
// 	".post-62",
// 	".wpcf7",
// 	".screen-reader-response",
// 	".wpcf7-form",
// 	".init",
// 	".col-lg-10",
// 	".form-group",
// 	".form-label",
// 	".wpcf7-form-control-wrap",
// 	".inputImie",
// 	".wpcf7-form-control",
// 	".wpcf7-text",
// 	".wpcf7-validates-as-required",
// 	".form-control",
// 	".inputEmail",
// 	".wpcf7-email",
// 	".wpcf7-validates-as-email",
// 	".inputOrganizacja",
// 	".inputTemat",
// 	".textarea-547",
// 	".wpcf7-textarea",
// 	".wpcf7-submit",
// 	".ajax-loader",
// 	".wpcf7-response-output",
// 	".page-id-48",
// 	".page-item-48",
// 	".post-48",
// 	".max-w-400px"
// ]